'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

SharedWidthSubscriberDirective=function(_BaseControllerBacked){_inherits(SharedWidthSubscriberDirective,_BaseControllerBacked);function SharedWidthSubscriberDirective(){_classCallCheck(this,SharedWidthSubscriberDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(SharedWidthSubscriberDirective,[{key:'restrict',get:function()
{
return'A';
}},{key:'textBindings',get:function()
{
return['name'];
}},{key:'controller',get:function()
{
return SharedWidthSubscriberDirectiveController;
}}]);return SharedWidthSubscriberDirective}(BaseControllerBackedDirective);let


SharedWidthSubscriberDirectiveController=function(){_createClass(SharedWidthSubscriberDirectiveController,null,[{key:'$inject',get:function()
{
return['$rootScope','$scope','$element'];
}}]);

function SharedWidthSubscriberDirectiveController($rootScope,$scope,$element){_classCallCheck(this,SharedWidthSubscriberDirectiveController);
this._$rootScope=$rootScope;

$scope.$watch('controller._sharedWidth',function(newWidth){
$element[0].style.width=`${newWidth}px`;
});
}_createClass(SharedWidthSubscriberDirectiveController,[{key:'_sharedWidth',get:function()

{
return _.exists(this._$rootScope.sharedWidths)?this._$rootScope.sharedWidths[this.name]:void 0;
}}]);return SharedWidthSubscriberDirectiveController}();


module.exports=SharedWidthSubscriberDirective;
//# sourceMappingURL=sharedWidthSubscriberDirective.js.map
